import { Avatar, Typography } from "@mui/material";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import providerIconMale from "src/assets/providerIconMale.png";

interface CardProps {
  text: string;
}

const InformationCard = ({ text }: CardProps) => {
  const isMobile = useIsMobile();
  return (
    <WhiteCard
      direction={isMobile ? "column" : "row"}
      sx={{ backgroundColor: "#ffffff" }}
      alignItems="center"
      gap={1}
    >
      <Avatar
        src={providerIconMale}
        alt="Provider"
        sx={{ height: "60px", width: "60px" }}
      />
      <Typography textAlign={isMobile ? "center" : "start"}>{text}</Typography>
    </WhiteCard>
  );
};

export default InformationCard;
